import React, { useState, useEffect } from "react";
import "./App.css";
import "./results.css";
import ResetButton from "./resetbutton";
import Lottie from "lottie-react";
import * as myLoader from "./toaster.json";

const Que = () => {
  const [question, setQuestion] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [highlightOption, setHighlightOption] = useState(null);
  const [questionHistory, setQuestionHistory] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchQuestion(1);
  }, []);

  const fetchQuestion = async (questionId) => {
    try {
      setError(null);
      const response = await fetch(
        `https://uxapi.vercel.app/questions/${questionId}`
      );
      const data = await response.json();
      setIsLoading(false);
      setQuestion(data);
    } catch (error) {
      console.error("Error fetching question:", error);
    }
  };

  const handleOptionSelect = (option, index) => {
    setSelectedOption(option);
    setHighlightOption(index);
  };

  const handleDivClick = async () => {
    if (selectedOption === null) {
      setError("Please select an option before proceeding.");
      console.warn("Please select an option before proceeding.");
      return;
    } else if (selectedOption === undefined) {
      console.warn("No que found");
      return;
    }
    setError(null);

    try {
      setQuestionHistory((prevHistory) => [...prevHistory, question]);

      await fetch(`https://uxapi.vercel.app/submit/${selectedOption}`, {
        method: "POST",
      })
        .then((res) => res.json())
        .then((res) => setQuestion(res.nextQuestion))
        .catch((errr) => console.log(errr));
      // handleOptionSelect(null);
      document.getElementById("myForm").reset();
    } catch (error) {
      console.error("Error submitting responses:", error);
    }
    setSelectedOption(null);
    setHighlightOption(null);
  };

  const handlePrevious = () => {
    const lastQuestion = questionHistory.pop();
    if (lastQuestion) {
      setQuestion(lastQuestion);
      setQuestionHistory([...questionHistory]);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="loader">
          <Lottie
            animationData={myLoader}
            loop={true}
            className="toastLoader"
          />
          LOADING...
        </div>
      ) : (
        <p></p>
      )}
      {question && (
        <div className="que-content">
          <h2>{question.text}</h2>
          <div className="qo">
            <form id="myForm">
              {error && (
                <p
                  style={{
                    backgroundColor: "#FFF2F2",
                    color: "red",
                    padding: "5px",
                    border: "2px solid red",
                    borderRadius: "5px",
                  }}
                >
                  {error}
                </p>
              )}

              {question.options.map((option, index) => (
                <div
                  id={index}
                  className="options"
                  name="options"
                  value={option.text}
                  key={index}
                  onClick={() =>
                    handleOptionSelect(option.nextQuestionId, index)
                  }
                  style={{
                    backgroundColor:
                      highlightOption === index ? "#F1FCFF" : "#fff",
                    cursor: "pointer",

                    border:
                      highlightOption === index
                        ? "2px solid #3a89ff"
                        : "1px solid #000",
                    marginBottom: "10px",
                    color: highlightOption === index ? "#000" : "#638790",
                    fontWeight: highlightOption === index ? "700" : "500",
                  }}
                >
                  {option.text}
                </div>
              ))}

              {question.result ? (
                <div className="rmethodName">{question.result} </div>
              ) : null}

              {question.result ? <ResetButton></ResetButton> : ""}
            </form>
          </div>

          <div
            className="formButtons"
            style={{
              display: question.result ? "none" : "show",
            }}
          >
            <div
              className="previousButton"
              onClick={handlePrevious}
              disabled={questionHistory.length === 0}
            >
              Previous
            </div>
            <div className="nextbtn" onClick={handleDivClick}>
              Next
            </div>
          </div>
          <div className="footer">
            <div>v 1.0.0</div>
            <div className="sendMsg">
              Any suggesstions?{" "}
              <a href="mailto:ajaysoni3740@gmail.com">Mail Me</a>
            </div>
            <div className="madeby">
              Made by{" "}
              <a href="https://www.linkedin.com/in/ajaysoniblogger/">
                Ajay Soni
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Que;
